import React from "react";
import './about.scss';
import Headshot from "../../assets/images/headshot.jpg";
import { Link } from 'react-router-dom';
import AnimatedPage from "../../components/animated-page";

const About = () => {
  return (
    <AnimatedPage>
      <div className="about">
      <div className="image-mask-rect">
        <img className="image" src={Headshot} alt="Headshot of Ravin Perera"/>
        </div>
        <div>
          <h1 className="heading">Hi, I'm Ravin.</h1>
          <div className="text-paragraph">
            <p>A Sri Lankan Canadian product designer currently based in London, UK. Growing up between two vastly different cultures, I have anchored my practice at the intersection between technology and culture. I am passionate about design that considers the impact on culture and iterates for better human interactions in society.</p>
            <p>9 years into my product design career, I have worked in various industries such as healthcare, CRM, audio, fintech, and recently in Gen AI. My background in industrial design helps me approach problems through a user-centered design approach while balancing business goals.
              I currently work as a senior product designer on the Office AI Design Labs team at Microsoft, building AI native software experiences through rapid prototyping with large language models. I design and build experimental interfaces in code, advancing multimodal and conversational interaction models that influence products across Microsoft 365, Copilot, and beyond.</p>
            <p>Previously, I led the design of Copilot Pages in the M365 Copilot mobile app, and also led design on <Link className="link" to="/copilot-rich-artifacts" target="_blank" rel="noopener noreferrer">rich artifacts on Copilot Pages</Link> on web.</p>
            <p>In January of 2021, I proudly launched my passion project <Link className="link" to="https://www.samana.lk/support-list" target="_blank" rel="noopener noreferrer">Samana</Link>, which is a centralized list of support services available in Sri Lanka.</p>
            <p>Aside from design, here are a few things I enjoy:</p>
                <ul>
                  <p>
                    <li>
                    Traveling to new places and experiencing new cultures.
                    </li>
                    <li>
                    Trying out and cooking food.
                    </li>
                    <li>
                    Taking travel photos and photos of food.
                    </li>
                    <li>
                    Playing Badminton.
                    </li>
                    <li>
                    Playing video games.
                    </li>
                    <li>
                    Petting dogs and cats.
                    </li>
                    <li>
                    Producing digital music on Ableton.
                    </li>
                  </p>
                </ul>
          </div>
        </div>
      </div>
    </AnimatedPage>
  );
};

export default About;